export default "__VITE_ASSET__hgR0VPKeoxf8ccJWimbDxw__"